import moment from "moment";
import { FC, useEffect, useState } from "react";
import { getStudentClassByDate } from "../../../api/campusClasses.api";
import { getCounsel, getStudentCounselMenu } from "../../../api/studentsCounsel.api";
import useAxios from "../../../hooks/useAxios";
import { IGetStudentClass } from "../../../models/campusClasses.model";
import { ICounselMenuResponse, IGetCounsel } from "../../../models/studentsCounsel.model";
import { ClassContents } from "../../../pages/tutor/class";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import CounselForm from "../../student/student/CounselForm";

interface IProps {
  counselCode: number|undefined;
  setContent: (content: ClassContents) => void;
}

const ReadCounseling: FC<IProps> = ({
  counselCode,
  setContent,
}) => {
  const { data: res, isLoading, error, execute } = useAxios<IGetCounsel>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<ICounselMenuResponse>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetStudentClass>();

  const [formMode, setFormMode] = useState('read');

  useEffect(() => {
    if (counselCode) {
      execute(getCounsel(counselCode));
    }
  }, [counselCode]);

  useEffect(() => {
    execute2(getStudentCounselMenu());
  }, []);

  useEffect(() => {
    if (res && !isLoading) {
      execute3(getStudentClassByDate({
        srtDate: moment().format('YYYYMMDD'),
        memberCode: res?.data?.studentMemberCode,
      }));
    }
  }, [res, isLoading]);

  return (
    <>
      {isLoading || isLoading2 || isLoading3 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />

      <CounselForm
        formMode={formMode}
        setFormMode={setFormMode}
        counsel={res?.data}
        menus={res2?.data ?? []}
        studentInfo={res3?.data}
        setContent={setContent}
      />
    </>
  );
}

export default ReadCounseling;
